export default "__VITE_ASSET__DVoqSJAL__"